import React from 'react';

import { Section } from '@/components/global/Section';
import { getLayoutClass } from '@/components/Template/Template3/utils';

import { TRecommendation } from '@/services/requests/Recommendation/types/template3';

import { Layout1 } from './Layout1';
import { Layout2 } from './Layout2';

type TProps = {
  data: TRecommendation[];
};

const TemplateVitrine3 = ({ data }: TProps) => {
  return (
    <Section className={getLayoutClass(data[0].layout)} data={data}>
      <div className="vitrine-template3__container">
        {data[0].layout.toString() === '1' ? (
          <Layout1 data={data[0]} />
        ) : (
          <Layout2 data={data[0]} />
        )}
      </div>
    </Section>
  );
};

export default TemplateVitrine3;
